import { useDeleteLifeAreaSection } from 'features/life-areas';
import { useLocalizedLifeAreaById } from 'features/life-areas/hooks/use-localized-life-area-by-id';
import React, { useRef } from 'react';
import { PopupMenu } from 'shared/components/ui/popup-menu';
import { useOpenDeleteLifeAreaSectionDialog } from 'shared/contexts/delete-life-area-section';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { ID } from 'shared/types/id';

import { EditList } from './edit-list';

export type LifeAreaSectionContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'ref'
> & {
  id: ID;
  lifeAreaId: ID;
  inputRef?: React.RefObject<HTMLInputElement>;
  onClose: () => void;
};

export const LifeAreaSectionContextMenu: React.FC<
  LifeAreaSectionContextMenuProps
> = ({
  id,
  lifeAreaId,
  inputRef,
  onClose,

  position,
  location,
  referenceElement,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { menuOpen: lifeAreaSelectOpen } = useOpenMenu();
  const lifeArea = useLocalizedLifeAreaById(lifeAreaId);

  const _onClose = () => {
    if (!lifeAreaSelectOpen) {
      onClose();
    }
  };

  const deleteLifeAreaSection = useDeleteLifeAreaSection();
  const openDeleteSectionDialog = useOpenDeleteLifeAreaSectionDialog();

  const onDeleteSection = () => {
    if (!lifeArea) {
      return;
    }

    const section = lifeArea.sections?.find((section) => section.id === id);

    if (!section) {
      onClose();
      return;
    }

    if (!section.tasks?.length) {
      // delete section right away
      deleteLifeAreaSection(lifeArea, id);
      onClose();
      return;
    }

    // open section delete dialog
    openDeleteSectionDialog(lifeArea, id);
    onClose();
  };

  return lifeArea ? (
    <PopupMenu
      ref={containerRef}
      location={location}
      position={position}
      referenceElement={referenceElement}
      onOutside={_onClose}
    >
      <EditList
        lifeArea={lifeArea}
        sectionId={id}
        inputRef={inputRef}
        onClose={onClose}
        onDeleteSection={onDeleteSection}
      />
    </PopupMenu>
  ) : null;
};
